import { SalesAidFile } from "./types";

export type EditDocumentForm = { name: string; code: string; groups: string[] };

export type SalesAidFileUpdate = { name?: string; code?: string; groups?: string[] };

export function toEditDocumentForm(file: SalesAidFile): EditDocumentForm {
  const groups = file.all_cohorts ? [] : file.groups ?? [];
  return { name: file.file_name, code: file.code ?? "", groups };
}

function sameMembers(a: string[], b: string[]) {
  return a.length === b.length && a.every((key) => b.includes(key));
}

// Only changed fields are sent, so an unrelated edit never rewrites the file's cohorts.
export function buildFileUpdate(file: SalesAidFile, form: EditDocumentForm): SalesAidFileUpdate {
  const initial = toEditDocumentForm(file);
  const update: SalesAidFileUpdate = {};
  const name = form.name.trim();
  const code = form.code.trim();
  if (name !== initial.name) update.name = name;
  if (code !== initial.code) update.code = code;
  if (!sameMembers(form.groups, initial.groups)) update.groups = form.groups;
  return update;
}
